import * as yup from 'yup'

import constants from 'constants/index'

const { EVIDENCE_FILE_TYPES, EVIDENCE_FILE_MIMES_TYPES } = constants.planAction

const schema = yup.object().shape({
  what: yup.string(),
  how: yup.string(),
  because: yup.string(),
  where: yup.string(),
  howPrice: yup.string(),
  link: yup.string(),
  startDate: yup
    .date()
    .required('Preencha a data do incidente')
    .typeError('Preencha a data do incidente'),
  deadlineDate: yup
    .date()
    .required('Preencha a data do incidente')
    .typeError('Preencha a data do incidente'),
  responsibleUserId: yup
    .number()
    .typeError('Preencha esse campo')
    .nullable()
    .required('Preencha esse campo'),
  justify: yup.string().max(5000),
  evidences: yup.mixed().fileUpload({
    types: EVIDENCE_FILE_TYPES,
    mimeTypes: EVIDENCE_FILE_MIMES_TYPES,
    sizeMessage: 'O documento deve ter no máximo 10 MB',
  }),
})

export default schema
